import FormationCard from "../Components/FormationCard";
import NavigationComp from "../Components/NavigationComp";
import Header from "../Components/Header";
import image_croix from "../Pages/image/croix.png"
import { useState } from "react";
import TrainingCompetence from "../Components/TrainingCompetence";
import TrainingObj from "../Components/TrainingObj";
import TrainingMaintien from "../Components/TrainingMaintien";
import SuccessRate from "../Components/SuccesRate";
import TrainingService from "../../Service/TrainingService";
import Incendie from "../Pages/image/Incendie.jpeg";
import Secourisme from "../Pages/image/Secourisme.jpg";
import Prevention from "../Pages/image/Prevention.jpg";
import Forma from "../Pages/image/Formation.jpg";
import MyLoader from "../Components/Loader";
import { Helmet } from "react-helmet";

const GetFormaCompView = (formationsData, training, loading, id) => {

    const [activeSection, setActiveSection] = useState('public-concerne'); // Default section
    const [showPopup, setShowPopup] = useState(false); // State for popup visibility
    const [editMode, setEditMode] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [link, setLink] = useState('');
    const [location, setLocation] = useState('');
    const token = sessionStorage.getItem('token');
    const trackPhoneConversion = () => {
        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-17898913995/_yBsCKvW5PMbEMuB79ZC',
                value: 1.0,
                currency: 'EUR',
            });
        }
    };

    const handleDeleteSession = async (sessionId) => {
        try {
            await TrainingService.deleteSession(sessionId); // Attendez que la suppression soit terminée
            console.log("Session deleted successfully");
            window.location.reload(); // Rechargez la page après le succès
        } catch (error) {
            console.error("Error deleting session:", error);
            alert("Une erreur est survenue lors de la suppression. Veuillez réessayer.");
        }
    };

    const handleSectionClick = (section) => {
        setActiveSection(section);
    };
    const handleEditClick = () => {
        setEditMode(true);
    };

    const handlePopupOpen = () => {
        setShowPopup(true);
    };

    const handlePopupClose = () => {
        setShowPopup(false);
    };

    const handleSaveClick = async () => {
        try {
            let response;
            if (training.modif) {
                response = await TrainingService.postSessions(startDate, endDate, link, training.idSecond, location);
            } else {
                response = await TrainingService.postModifTraining(training);
                await TrainingService.postSessions(startDate, endDate, link, response.data.id, location);
            }
            // Refresh the page
            window.location.reload();
        } catch (error) {
            console.log("Error: " + error);
        }
    };

    return (
        <>
            <Helmet>
                <title>
                    {loading || !training?.name
                        ? "Formation"
                        : training.name
                            .replace(
                                /Inter-Entreprise|Intra-Entreprises|Intra-Entreprise|- Inter-Entreprises et individuels|- Inter-Entreprises et Individuels| - Intra-Entreprise|- Inter|s et Individuels/g,
                                ""
                            )
                            .trim()}
                </title>
                <meta name="description" content="Formation" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            {
                loading ? (
                    <Header title={"Formation"} image={Forma}></Header>
                ) : (
                    training.type == 1 ? (
                        <Header title={training.name.replace(/Inter-Entreprise|Intra-Entreprises|Intra-Entreprise|- Inter-Entreprises et individuels|- Inter-Entreprises et Individuels| - Intra-Entreprise|- Inter|s et Individuels/g, "").trim()} type="Incendie" image={Forma} />
                    ) : training.type == 2 ? (
                        <Header title={training.name.replace(/Inter-Entreprise|Intra-Entreprises|Intra-Entreprise|- Inter-Entreprises et individuels|- Inter-Entreprises et Individuels| - Intra-Entreprise|- Inter|s et Individuels/g, "").trim()} type="Secourisme" image={Forma} />
                    ) : (
                        <Header title={training.name.replace(/Inter-Entreprise|Intra-Entreprises|Intra-Entreprise|- Inter-Entreprises et individuels|- Inter-Entreprises et Individuels| - Intra-Entreprise|- Inter|s et Individuels/g, "").trim()} type="Prévention des risques" image={Forma} />
                    )
                )

            }
            <div className="fiche">
                <NavigationComp idtrain={id} />
                <main className="main-forma">
                    <section className="public-concerne">
                        <div className="title_forma" onClick={() => handleSectionClick('public-concerne')}>
                            <h2 className={`section-title-formas ${activeSection === 'public-concerne' ? 'section-title-selected' : ''}`}>
                                Objectifs
                            </h2>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/71096cff5ed628cce68a8d4f7dad8faafac9a479d853cfb142c4772965c15498?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
                                alt="Public concerné icon"
                                className={`section-icon ${activeSection === 'public-concerne' ? 'rotated' : ''}`}
                            /></div>
                        {loading ? (
                            MyLoader()
                        ) : (
                            activeSection === 'public-concerne' && <TrainingObj training={training} />
                        )}
                    </section>

                    <div className="section-underline" />

                    <section className="presentation">
                        <div
                            className="title_forma"
                            onClick={() => handleSectionClick('presentation')}
                        >
                            <h2 className={`section-title-formas ${activeSection === 'presentation' ? 'section-title-selected' : ''}`}>
                                Thématique de la formation
                            </h2>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/71096cff5ed628cce68a8d4f7dad8faafac9a479d853cfb142c4772965c15498?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
                                alt="Public concerné icon"
                                className={`section-icon ${activeSection === 'presentation' ? 'rotated' : ''}`}
                            /></div>
                        {loading ? (
                            MyLoader()
                        ) : (
                            activeSection === 'presentation' && (
                                <TrainingCompetence training={training} />
                            ))}
                    </section>



                    <div className="section-underline" />

                    <section className="maintien">
                        <div
                            className="title_forma"
                            onClick={() => handleSectionClick('maintien')}
                        >
                            <h2 className={`section-title-formas ${activeSection === 'maintien' ? 'section-title-selected' : ''}`}>
                                Maintien et actualisation des compétences
                            </h2>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/71096cff5ed628cce68a8d4f7dad8faafac9a479d853cfb142c4772965c15498?apiKey=59156c16963f46e28d2e0d857e2bfa45&"
                                alt="Public concerné icon"
                                className={`section-icon ${activeSection === 'maintien' ? 'rotated' : ''}`}
                            /></div>
                        {loading ? (
                            MyLoader()
                        ) : (
                            activeSection === 'maintien' && <TrainingMaintien training={training} />)}
                    </section>
                    <section className="inscription">
                        <img src="https://cdn.builder.io/api/v1/image/assets/TEMP/2488b63850ab96fb369010bbf78f462b180f78dc5785dc6cb30aa459e1a3a141?apiKey=59156c16963f46e28d2e0d857e2bfa45&" alt="Inscription illustration" className="inscription-image" />
                        <div className="inscription-content">
                            <h2 className="inscription-title">
                                {training.ins_title || "Vous souhaitez participer à notre prochaine session ?"}
                            </h2>

                            <h3 className="inscription-title">
                                {training.ins_subtitle || "Rejoignez Nous !"}
                            </h3>

                            <div className="buttons">

                                <a className="inscription-button" href="tel:0951092832" onClick={trackPhoneConversion}>
                                    {training.ins_button_tel || "Appellez nous"}
                                </a>

                                <button className="inscription-button" onClick={handlePopupOpen}>
                                    {training.ins_button || "Demander les prochaines sessions"}
                                </button>

                            </div>
                        </div>
                    </section>
                    {loading ? (
                        <></>
                    ) : (
                        training.rating || token === '' ? (<SuccessRate training={training} />) : null
                    )}
                    {loading ? (
                        <></>
                    ) : (
                        training.document ? (<a href={"https://sc-formation-prevention-secours.hop3team.com/" + training.document} className="btn btn-danger" style={{ marginLeft: "40%", marginTop: "2%" }}>Télécharger la fiche</a>) : null
                    )}

                    <section className="autres-formations">
                        <h2 className="section-title-formas">Autres Formations</h2>
                        <div className="row">
                            {loading ? (
                                MyLoader()
                            ) : (
                                formationsData.map((formation, index) => (
                                    <a href={"/formation/" + formation.id} className="col-md-4 mb-4">
                                        <div key={index}>
                                            <div className="card ssip3-card">
                                                {formation.training_cycle.id === 1 ? (
                                                    <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/25af45e77d6bdad6be0823e485e1185dbcade06700e334c8679be0e3beea81f8?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                                                ) : formation.training_cycle.id === 2 ? (
                                                    <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/a0a73d9596425af046d195ca798473528c2f8d418be124f00087b8b935102ee7?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                                                ) : (<img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/ad826d4b70d96ec1d03af674552d8991a3c18ddf6c062a52ef99778dc6fc8a99?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />)}
                                                <div className="card-body text-center">
                                                    <div className="ssip3-overlay">
                                                        <h1 className="ssip3-title">{formation.name}</h1>
                                                    </div>
                                                    {formation.training_cycle.id === 1 ? (
                                                        <div className="ssip3-tag">Incendie</div>
                                                    ) : formation.training_cycle.id === 2 ? (
                                                        <div className="ssip3-tag-2">Secourisme</div>
                                                    ) : (<div className="ssip3-tag-3">Prévention des risques</div>)}
                                                </div>
                                            </div>
                                        </div></a>
                                ))
                            )}

                        </div>
                        <a href="/formations" className="voir-toutes">Voir toutes les formations &gt;</a>
                    </section>
                </main>
            </div >
            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <h3>Dates pour l'inscription</h3>
                        {training.sessions && training.sessions.length > 0 ? (
                            training.sessions.map((session, index) => {
                                // Convert dates to Date objects for comparison
                                const formattedDateDebut = new Date(session.dateDebut).toLocaleDateString('fr-FR', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                });
                                const dateFin = new Date(session.dateFin);
                                const formattedDateFin = dateFin.toLocaleDateString('fr-FR', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                });
                                const now = new Date();

                                let locations

                                if (!session.location){
                                    locations = "Valenciennes"
                                }else{
                                    locations = session.location
                                }


                                if (dateFin < now) {
                                    return (
                                        <>
                                            <p key={index}>{"du " + formattedDateDebut + " au " + formattedDateFin + " à " + locations + " - Terminer"}</p>
                                            {token === '' && (
                                                <button
                                                    className="inscription-button delete_button"
                                                    onClick={() => handleDeleteSession(session.id)}
                                                    style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
                                                >
                                                    Supprimer
                                                </button>
                                            )}
                                            <br />
                                            <br />
                                        </>
                                    );
                                } else if (formattedDateDebut == formattedDateFin) {
                                    return (
                                        <>
                                            <a key={index} href={session.link}>
                                                {"Le " + formattedDateDebut + " à " + locations}
                                            </a>
                                            {token === '' && (
                                                <button
                                                    className="inscription-button delete_button"
                                                    onClick={() => handleDeleteSession(session.id)}
                                                    style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
                                                >
                                                    Supprimer
                                                </button>
                                            )}
                                            <br />
                                            <br />
                                        </>
                                    );
                                } else {
                                    return (
                                        <>
                                            <a key={index} href={session.link}>{"du " + formattedDateDebut + " au " + formattedDateFin + " à " + locations}</a>
                                            {token === '' && (
                                                <button
                                                    className="inscription-button delete_button"
                                                    onClick={() => handleDeleteSession(session.id)}
                                                    style={{ marginLeft: '10px', backgroundColor: 'red', color: 'white' }}
                                                >
                                                    Supprimer
                                                </button>
                                            )}
                                            <br />
                                            <br />
                                        </>
                                    );
                                }
                            })
                        ) : (
                            <p>Pas de date disponible</p>
                        )}
                        {/* Formulaire en mode édition */}


                        {editMode ? (
                            <form>
                                <div className="form-group">
                                    <label htmlFor="startDate">Date de début :</label>
                                    <input
                                        type="date"
                                        id="startDate"
                                        className="form-control"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="endDate">Date de fin :</label>
                                    <input
                                        type="date"
                                        id="endDate"
                                        className="form-control"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="location">Ville :</label>
                                    <input
                                        type="text"
                                        id="location"
                                        className="form-control"
                                        placeholder="Valenciennes"
                                        onChange={(e) => setLocation(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="link">Lien :</label>
                                    <input
                                        type="url"
                                        id="link"
                                        className="form-control"
                                        placeholder="https://votre-lien.com"
                                        value={link}
                                        onChange={(e) => setLink(e.target.value)}
                                    />
                                </div>
                            </form>
                        ) : (
                            token === '' && (
                                <button
                                    className="inscription-button modif_button"
                                    onClick={handleEditClick}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Ajouter des dates
                                </button>
                            )
                        )}

                        {/* Boutons d'action */}
                        {editMode ? (
                            <button
                                className="inscription-button modif_button"
                                onClick={handleSaveClick}
                                style={{ right: 0 }}
                            >
                                Enregistrer
                            </button>
                        ) : null}
                        <button onClick={handlePopupClose}>Fermer</button>
                    </div>
                </div>
            )}</>
    )
}

export default GetFormaCompView;